



































import { defineComponent } from '@vue/composition-api';

type ConsentMode = 'granted' | 'denied';
type ConsentUpdatePayload = {
  'analytics_storage': ConsentMode;
  'ad_storage': ConsentMode;
};
type GtagClient = {
  query?: (command: string, action: string, params: ConsentUpdatePayload) => void;
};
type CookieBannerVm = {
  $gtag?: GtagClient;
};

export default defineComponent({
  name: 'CookieBanner',
  data(): { isOpen: boolean } {
    return {
      isOpen: false
    };
  },
  mounted(): void {
    const consent = localStorage.getItem('cookieconfig');

    // Always start with cookieless tracking (handled in main.ts config)
    // If previously accepted, we upgrade to full cookies immediately
    if (consent === 'accepted') {
      this.enableCookies();
    } else if (!consent) {
      this.isOpen = true; // Show banner if no choice made
    }

    this.$root.$on('open-cookie-settings', this.openBanner);
  },
  beforeDestroy(): void {
    this.$root.$off('open-cookie-settings', this.openBanner);
  },
  methods: {
    openBanner(): void {
      this.isOpen = true;
    },
    accept(): void {
      localStorage.setItem('cookieconfig', 'accepted');
      this.enableCookies();
      this.isOpen = false;
    },
    decline(): void {
      localStorage.setItem('cookieconfig', 'declined');
      this.disableCookies();
      this.isOpen = false;
    },
    enableCookies(): void {
      const vm = this as unknown as CookieBannerVm;
      if (vm.$gtag && typeof vm.$gtag.query === 'function') {
        // Consent Mode Update: Erlaubt das Setzen von Cookies
        vm.$gtag.query('consent', 'update', {
          'analytics_storage': 'granted',
          'ad_storage': 'granted'
        });
      }
    },
    disableCookies(): void {
      const vm = this as unknown as CookieBannerVm;
      if (vm.$gtag && typeof vm.$gtag.query === 'function') {
         // Consent Mode Update: Verbietet das Setzen von Cookies
         vm.$gtag.query('consent', 'update', {
           'analytics_storage': 'denied',
           'ad_storage': 'denied'
         });
      }
    }
  }
});
